import { FormLabel } from '@mui/material';
import React, { useMemo } from 'react';
import { useUpdateInsightClaimMutation } from '@/features/claims/ticketsApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import InsightSelect from '../InsightSelect';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';

export const ClaimTypeSelectWrapper = ({ minimal, noLabel, required }) => {
	const { dealRow, claim } = useObjectContext();

	const claimType = useMemo(
		() => ({
			Id: claim?.SubjectId,
			Name: claim?.SubjectName,
			Description: claim?.SubjectOfLoss,
		}),
		[claim?.SubjectId, claim?.SubjectName, claim?.SubjectOfLoss],
	);

	const [updateDealRow, { isLoading: isUpdatingDealRow }] = useUpdateDealRowMutation();
	const [updateInsightClaim, { isLoading: isLoadingClaimUpdate }] =
		useUpdateInsightClaimMutation();

	const handleClaimTypeChange = async (value) => {
		try {
			await updateDealRow({
				dealId: dealRow?.dealId,
				properties: {
					claimType: value.Description ?? value.Name ?? '',
					claimTypeId: value.Id ?? null,
				},
			}).unwrap();

			await updateInsightClaim({
				dealId: dealRow?.id,
				properties: {
					SubjectId: value.Id,
				},
			}).unwrap();
		} catch (error) {
			console.error('Error updating claim:', error);
		}
	};

	return (
		<ClaimTypeSelect
			claimType={claimType}
			setClaimType={handleClaimTypeChange}
			minimal={minimal}
			noLabel={noLabel}
			loading={isLoadingClaimUpdate || isUpdatingDealRow}
			disabled={!dealRow || isLoadingClaimUpdate || isUpdatingDealRow}
			required={required}
		/>
	);
};

const ENDPOINT = '/ClaimSubjectOfLoss/List';

export const ClaimTypeSelect = ({
	claimType,
	disabled,
	loading,
	setClaimType,
	minimal,
	noLabel,
	required,
	error,
}) => {
	return (
		<>
			{!noLabel && (
				<FormLabel required={required}>{'Subject of Loss'}</FormLabel>
			)}
			<InsightSelect
				name={'claimType'}
				endpoint={ENDPOINT}
				value={claimType}
				onChange={setClaimType}
				{...{
					error,
					disabled,
					minimal,
					canSearch: true,
					loading,
				}}
			/>
		</>
	);
};
